module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
  "use strict";

  var _ = {
    loginEmailPairDBValidator: function (value) {
      var api = this.getApi("checkCredentionalsApi", {
        method: "user.checkLoginAndEmailAvailability",
        httpMethod: "post",
      });

      var values = value.split("/");

      return api
        .psend({
          login: values[0],
          email: values[1],
          returnError: true,
        })
        .then(function (resp) {
          resp = fox.objectGet(resp, "params.answer.response");

          return {
            result: resp.checkingStatus,
            data: resp,
          };
        });
    },
  };

  fox.registerWidget("Join_Form_Home", {
    configure: function (options) {
      this.registerOptions("", {
        autoRender: true,
        "embed.container": ".join-form-wrapper",
        template: "join_form_home",

        widgets: {
          form: {
            widget: "DomForm",
            formSelector: ".join-form",
            elements: {
              login_email: {
                type: "computed",
                combine: ["login", "email"],
                validators: [
                  function (value) {
                    var values = value.split("/").filter(function (v) {
                      return !fox.isEmpty(v);
                    });

                    return {
                      result:
                        values.length === 2 && fox.regexp.email.test(values[1]),
                    };
                  },
                  _.loginEmailPairDBValidator.bind(this),
                ],
              },
            },
          },
        },

        handleDom: {
          gotoStep2: {
            target: ".step2",
            event: "click",
            callback: "submit",
          },
          focus: {
            target: "input",
            event: "focus",
            callback: function (el) {
              var $node = $(el);

              $node
                .parent()
                .removeClass("error")
                .next()
                .text("")
                .removeClass("show");
            },
          },
        },
        handleWom: {
          formIsEmpty: {
            event: "form_not_valid",
            widget: "#form",
            callback: function (params) {
              function showError($node, message) {
                $node
                  .parent()
                  .addClass("error")
                  .next()
                  .text(message)
                  .addClass("show");
              }

              params.forEach(function (row) {
                var element = this.form.getElement(row.field);

                switch (true) {
                  case fox.inArray(["email", "login"], row.field):
                    return (
                      element.nodes &&
                      !row.result &&
                      showError(
                        $(element.nodes[0]),
                        element.nodes[0].validationMessage
                      )
                    );
                  case row.field === "login_email":
                    fox.each(
                      row.data,
                      function (val, key) {
                        return (
                          fox.isObject(val) &&
                          !val.checkingStatus &&
                          showError(
                            $(this.form.getElement(key).nodes[0]),
                            val.errors
                          )
                        );
                      },
                      this
                    );
                    break;
                }
              }, this);
            },
          },
        },
      });

      this.callParent("configure", arguments);
    },

    running: function () {
      this.form = this.wom1("#form");
      this.gf = fox.wom.selectFirst("@root #joinFormStep1");

      this.callParent("running", arguments);
    },

    submit: function () {
      return this.form
        .submit()
        .then(
          function (values) {
            function setValue(key, value) {
              var element = this.gf.getElement(key);

              if (!element) {
                element = this.gf._addElement(fox.FormElementBase, {
                  name: key,
                });
              }

              element.setValue(value);
            }

            return (
              values &&
              fox.getObjectKeys(values).every(function (key) {
                key.split("_").forEach(function (key, idx, arr) {
                  return (
                    (key in values && setValue.call(this, key, values[key])) ||
                    setValue.call(
                      this,
                      key,
                      values[arr.join("_")].split("/")[idx]
                    )
                  );
                }, this);

                return true;
              }, this)
            );
          }.bind(this)
        )
        .then(
          function (res) {
            if (!res) return false;

            var joinFake = this.embedWidget("joinFake", "SitePage_Join", {
              active: true,
              "embed.container": ".fake-container",
            }).run();

            if (!fox.getEnv("siteProps.freeJoin")) {
              return this.gotoStep2();
            } else {
              return new fox.Promise(
                function (resolve, reject) {
                  joinFake = this.rwom1("#joinFake");
                  joinFake
                    .rwom1("#customJoin")
                    .onSubmit(this.gf.getValues(), resolve, reject);
                }.bind(this)
              ).then(function () {
                return joinFake;
              });
            }
          }.bind(this)
        );
    },

    gotoStep2: function () {
      fox.site.gotoPage("join/step2");
    },
  });
})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/home/joinForm.js
// module id = 1125
// module chunks = 4